var React = require('react');

function Books (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Warstwa_2","data-name":"Warstwa 2","transform":"translate(-0.001 -0.001)"},React.createElement("g",{"id":"Warstwa_1","data-name":"Warstwa 1"},React.createElement("path",{"id":"Path_6","data-name":"Path 6","d":"M29.36,14.56a4.62,4.62,0,0,0-1-2.44l.45-.15V4.49S20.3.88,19.31.35A3.88,3.88,0,0,0,16.67.14S4.69,4.22,2.38,5.22a3.47,3.47,0,0,0-2,2.12,2.43,2.43,0,0,0-.18.49,4.39,4.39,0,0,0,.26,3.26l.09,7.14,11.94,6.19S26,19.83,27.43,19.15c1.65-.82,2.14-3,1.93-4.59M3.05,7.65c.94.5,9.51,4.89,9.51,4.89L27.41,7.08v3.65l-14.85,5.4S4,12,2.78,11.17c-2-1.4-.93-4.14.27-3.52m23.4,9.86c-1.22.87-13.91,4.93-13.91,4.93L2.16,16.94V13l10.42,5.4s12.53-4.6,13.66-5c1.28-.42,2.18,2.71.21,4.11","fill":"#14171c"}))));
}

Books.defaultProps = {"width":"29.405","height":"24.419","viewBox":"0 0 29.405 24.419"};

module.exports = Books;

Books.default = Books;
